import { get, postj } from '@/utils/request';

export const usersInfo = (data) => get('users/userInfo',data); // 公告详情
export const usersUpdate = (data) => postj('users/update',data); // 编辑